import { type TestProps } from '@direct-frontend/components';
import { ONBOARDING_KIT_STEPS } from '#shared/api/onboarding';
import { stepsProps, subtasksProps } from '../../model/onboardingStages';
import { OnboardingStepsRenderer } from '../OnboardingStepsRenderer';
import { KitPublishButton } from './KitPublishButton';
import { KitWelcomeModal } from './KitWelcomeModal';

export function KitOnboardingStepper(props: TestProps) {
    return (
        <>
            <KitWelcomeModal />
            <OnboardingStepsRenderer
                {...props}
                PublishButton={KitPublishButton}
                publishSlug={ONBOARDING_KIT_STEPS.PUBLISH}
                stepsProps={stepsProps}
                subtasksProps={subtasksProps}
            />
        </>
    );
}
